import { useState, useEffect } from 'react';
import { Capacitor } from '@capacitor/core';

export const useIsIOS = () => {
  const [isIOS, setIsIOS] = useState(false);
  const [isIPad, setIsIPad] = useState(false);
  const [isIPhone, setIsIPhone] = useState(false);
  const [screenSize, setScreenSize] = useState<'small' | 'medium' | 'large'>('small');
  const [orientation, setOrientation] = useState<'portrait' | 'landscape'>('portrait');

  useEffect(() => {
    // Só detecta iOS se for plataforma nativa (Capacitor)
    const isNative = Capacitor.isNativePlatform();
    const platform = Capacitor.getPlatform();
    
    if (isNative && platform === 'ios') {
      const userAgent = navigator.userAgent.toLowerCase();
      const isIOSDevice = /iphone|ipad|ipod/.test(userAgent);
      
      // FORÇA iPad a ser sempre false - app funciona apenas em iPhone
      const isIPadDevice = false; // Sempre false - não suporta iPad
      
      const isIPhoneDevice = /iphone|ipod/.test(userAgent) || /ipad/.test(userAgent); // iPad é tratado como iPhone

      setIsIOS(isIOSDevice);
      setIsIPad(isIPadDevice);
      setIsIPhone(isIPhoneDevice);

      // Sempre usa tamanho pequeno (iPhone)
      setScreenSize('small');
      setOrientation('portrait');
    } else {
      // Em web, sempre false
      setIsIOS(false);
      setIsIPad(false);
      setIsIPhone(false);
    }
  }, []);

  return { 
    isIOS, 
    isIPad, 
    isIPhone, 
    screenSize, 
    orientation,
    isIPadLarge: false, // Sempre false
    isIPadMedium: false, // Sempre false
    isIPadSmall: false // Sempre false
  };
};

export default useIsIOS; 